<template>
  <div
    v-bind:class="{'view-room-details-table':true, 'room-unavailable': !roomIsAvailable, 'showing-strike-through': $store.getters.showingPreferredOffer}">
    <h2>
      <span>Order {{ currentViewText }}</span>
      <div class="clearme"></div>
      <a class="change-view" href="#" @click.prevent="toggleMode">View {{ changeViewText }}</a>
    </h2>
    <table role="presentation">
      <tbody>
      <tr>
        <td class="title" data-tooltip="Use buttons to change.">Adults</td>
        <td class="display-NUM-OF-ADULTS" colspan="2">
								<span class="control">
									<span class="value">
										{{ $store.state.bookingLinkData.adults }}
									</span>
									<a title="Decrement number of adults"
                     v-bind:class="{decrement: true, disabled: $store.state.adultMin === $store.state.bookingLinkData.adults}"
                     v-on:click.prevent="$store.commit('decrementAdults')" v-on:mousedown="controlMousedown"
                     v-on:mouseup="controlMouseup" href="#view-room-details-table"><svg><use
                    xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_remove_circle"></use></svg></a>
									<a title="Increment number of adults"
                     v-bind:class="{increment: true, disabled: $store.state.adultMax === $store.state.bookingLinkData.adults}"
                     v-on:click.prevent="$store.commit('incrementAdults')" v-on:mousedown="controlMousedown"
                     v-on:mouseup="controlMouseup" href="#view-room-details-table"><svg><use
                    xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_add_circle"></use></svg></a>
								</span>
        </td>
      </tr>
      <tr>
        <td class="title" data-tooltip="Use buttons to change.">Children</td>
        <td class="display-NUM-OF-CHILDREN" colspan="2">
								<span class="control">
									<span class="value">
										{{ $store.state.bookingLinkData.children }}
									</span>
									<a title="Decrement number of children"
                     v-bind:class="{decrement: true, disabled: $store.state.childMin === $store.state.bookingLinkData.children}"
                     v-on:click.prevent="$store.commit('decrementChildren')" v-on:mousedown="controlMousedown"
                     v-on:mouseup="controlMouseup" href="#view-room-details-table"><svg><use
                    xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_remove_circle"></use></svg></a>
									<a title="Increment number of children"
                     v-bind:class="{increment: true, disabled: $store.state.childMax === $store.state.bookingLinkData.children}"
                     v-on:click.prevent="$store.commit('incrementChildren')" v-on:mousedown="controlMousedown"
                     v-on:mouseup="controlMouseup" href="#view-room-details-table"><svg><use
                    xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_add_circle"></use></svg></a>
								</span>
        </td>
      </tr>
      <tr class="mobile-hidden">
        <td class="title">Check-In</td>
        <td class="display-CHECK-IN-DATE" v-html="checkInDateDisplay"></td>
        <td align="right" rowspan="2"><a class="change-dates" href="#" v-on:click.prevent="openCalendar"><span
          v-show="!calendarOpen">Change<br/>Dates</span><span v-show="calendarOpen">Close</span></a></td>
      </tr>
      <tr class="mobile-hidden">
        <td class="title">Check-Out</td>
        <td class="display-CHECK-OUT-DATE" v-html="checkOutDateDisplay"></td>
      </tr>
      <tr class="mobile-only">
        <td>&nbsp;</td>
        <td colspan="2">
          <a class="change-dates" href="#" v-on:click.prevent="openCalendar"><span
            v-show="!calendarOpen">Change Dates</span><span v-show="calendarOpen">Close</span></a>
        </td>
      </tr>
      <tr class="mobile-only">
        <td class="title">Check-In</td>
        <td class="display-CHECK-IN-DATE" colspan="2" v-html="checkInDateDisplay"></td>
      </tr>
      <tr class="mobile-only">
        <td class="title">Check-Out</td>
        <td class="display-CHECK-OUT-DATE" colspan="2" v-html="checkOutDateDisplay"></td>
      </tr>
      <tr v-bind:class="{'check-in-out-calendar':true, 'show-loading-spinner': !calendarLoaded && calendarOpen}"
          v-show="calendarOpen">
        <td colspan="3">
          <component ref="calendar" v-bind:is="calendarComponent" :change-dates-callback="changeDatesCallback"
                     disallow-sold-out-dates is-display-vertical @close="calendarOpen = false"></component>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="summary" v-show="summaryMode">
      <table role="presentation">
        <tbody>
        <tr class="mobile-hidden">
          <td class="title"><a class="change-view" href="#" @click.prevent="toggleMode">View Daily Rates</a></td>
          <td>&nbsp;</td>
        </tr>
        <tr class="mobile-only">
          <td>&nbsp;</td>
          <td><a class="change-view" href="#" @click.prevent="toggleMode">View Taxes/Fees</a></td>
        </tr>
        <tr>
          <td class="title">Room Subtotal</td>
          <td class="display-ROOM-SUBTOTAL">
            {{ $store.state.currentSubtotal }}
            <span v-if="strikeThroughSubtotal > 0" class="strike less-emphasis">{{
                currentSubtotalStrikeThrough
              }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Room Tax</td>
          <td class="display-STATE-TAX">
            <span>{{ $store.state.currentStateTax }}</span>
            <span v-if="strikeThroughStateTax > 0" class="strike less-emphasis">{{
                currentStateTaxStrikeThrough
              }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Resort Fee</td>
          <td class="display-RESORT-FEE">
            <span>{{ $store.state.currentResortFee }}</span>
            <a title="Resort Fee" class="info" @click.prevent.stop="showTooltipResortFee" href="#">
              <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_info"></use>
              </svg>
            </a>
          </td>
        </tr>
        <tr>
          <td class="title">Resort Fee Tax</td>
          <td class="display-RESORT-FEE-TAX">
            <span>{{ $store.state.currentResortFeeTax }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Tourism Surcharge</td>
          <td class="display-TOURISM-SURCHARGE">
            <span>{{ $store.state.currentTourismSurcharge }}</span>
            <a title="Tourism Surcharge" class="info" @click.prevent.stop="showTooltipTourismSurcharge" href="#">
              <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_info"></use>
              </svg>
            </a>
          </td>
        </tr>
        <tr>
          <td class="title">
            <strong>Total</strong>
          </td>
          <td class="display-TOTAL">
            <strong><span>{{ $store.state.currentTotal }}</span></strong>
            <span v-if="strikeThroughTotal > 0" class="strike less-emphasis">{{ currentTotalStrikeThrough }}</span>
            <a title="Display Total" class="info" @click.prevent.stop="showTooltipTotal" href="#">
              <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_info"></use>
              </svg>
            </a>
          </td>
        </tr>
        <tr class="preferred-savings" v-if="$store.getters.showingPreferredOffer && preferredRateDifference.length">
          <td class="title">Preferred Savings!</td>
          <td><span class="preferred-savings-display">{{ preferredRateDifference }}</span></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="details" v-show="!summaryMode">
      <table role="presentation">
        <tbody>
        <tr>
          <td class="title">Nights</td>
          <td class="display-NUM-OF-NIGHTS">
            <span>{{ $store.state.bookingLinkData.stayLength }}</span>
          </td>
        </tr>
        <tr v-for="rate in dailyRates" class="daily-rate" v-bind:data-rate-date="rate.date">
          <td class="title" v-html="rate.displayDate"></td>
          <td>
            <span>{{ rate.price }}</span>
            <span v-if="rate.priceStrikeThrough.length" class="strike less-emphasis">{{
                rate.priceStrikeThrough
              }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Room Subtotal</td>
          <td class="display-ROOM-SUBTOTAL">
            {{ $store.state.currentSubtotal }}
            <span v-if="strikeThroughSubtotal > 0" class="strike less-emphasis">{{
                currentSubtotalStrikeThrough
              }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Room Tax</td>
          <td class="display-STATE-TAX">
            <span>{{ $store.state.currentStateTax }}</span>
            <span v-if="strikeThroughStateTax > 0" class="strike less-emphasis">{{
                currentStateTaxStrikeThrough
              }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Resort Fee</td>
          <td class="display-RESORT-FEE">
            <span>{{ $store.state.currentResortFee }}</span>
            <a title="Resort Fee" class="info" @click.prevent.stop="showTooltipResortFee" href="#">
              <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_info"></use>
              </svg>
            </a>
          </td>
        </tr>
        <tr>
          <td class="title">Resort Fee Tax</td>
          <td class="display-RESORT-FEE-TAX">
            <span>{{ $store.state.currentResortFeeTax }}</span>
          </td>
        </tr>
        <tr>
          <td class="title">Tourism Surcharge</td>
          <td class="display-TOURISM-SURCHARGE">
            <span>{{ $store.state.currentTourismSurcharge }}</span>
            <a title="Tourism Surcharge" class="info" @click.prevent.stop="showTooltipTourismSurcharge" href="#">
              <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_info"></use>
              </svg>
            </a>
          </td>
        </tr>
        <tr>
          <td class="title"><strong>Total</strong></td>
          <td class="display-TOTAL">
            <strong><span>{{ currentTotal }}</span></strong>
            <span v-if="strikeThroughTotal > 0" class="strike less-emphasis">{{ currentTotalStrikeThrough }}</span>
            <a title="Show Total" class="info" @click.prevent.stop="showTooltipTotal" href="#">
              <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_info"></use>
              </svg>
            </a>
          </td>
        </tr>
        <tr class="preferred-savings" v-if="$store.getters.showingPreferredOffer">
          <td class="title">Preferred Savings!</td>
          <td><span class="preferred-savings-display">{{ preferredRateDifference }}</span></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
/*!
 * Copyright (C) 2019-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2022-06-23
 *			- <view-room-details-table> now uses getter for showingPreferredOffer".
 *
 *		2022-06-23
 *			- <view-room-details-table> now handles calendar callbacks.
 *
 *		2023-02-16
 *			- Display taxes and fees by default in <view-room-details-table>.
 *
 *		2023-04-14
 *			- Change "Subtotal" to "Room Subtotal" and move it up in the list of taxes/fees in <view-room-details-table>.
 *
 *		2023-08-28
 *			- Update stayLength in <view-room-details-table>::rateCalendarReload().
 *
 *		2024-06-10 (jhoward)
 *			- Implement Typescript in <view-room-details-table>.
 *			- Add descriptive title, aria-label, and role attributes in <view-room-details-table>.
 *			- Refactor for new <hotel-calendar> component in <view-room-details-table>.
 */
import {mapGetters, mapState} from 'vuex';
import HotelCalendar, {HotelCalendarComponent} from "../hotel/hotelCalendar.vue";
import {HotelBookingLinkData, ViewRoomDetailsHotelRoomData} from "../hotel/defs";
import {CalendarDay} from "../hotel/hotelCalendarDay.vue";
import { defineComponent } from 'vue';

interface GetRoomDataViewRoomDetailsResponse {
  STATUS: 'SUCCESS' | 'ERROR';
  DATA: {
    ROOM_DATA: ViewRoomDetailsHotelRoomData[];
    BOOKING_LINK_DATA: HotelBookingLinkData;
  };
}

export default defineComponent({
  name: "view-room-details-table",
  components: {
    HotelCalendar
  },
  props: {
    preferredRateDifference: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      summaryMode: true,

      calendarOpen: false,
      calendarLoaded: false,
      calendarComponent: ''
    };
  },
  computed: {
    ...mapState([
      'allowedOfferCodesForPreferred',
      'bookingLinkData',
      'useResortFee',
      'resortFeeSubtotal',
      'resortFeeTax',
      'roomData',
      'strikeThroughStateTax',
      'strikeThroughSubtotal',
      'strikeThroughTotal',
      'adultMin',
      'adultMax',
      'childMin',
      'childMax',
      'currentTotal',
      'currentStateTax',
      'currentResortFee',
      'currentResortFeeTax',
      'currentTourismSurcharge',
      'currentSubtotal',
      'tooltipTourismSurcharge',
      'tooltipResortFee',
      'tooltipTotal',
      'checkInDate',
      'checkOutDate',
    ]),
    ...mapGetters([
      'showingPreferredOffer',
      'currentRoomType',
    ]),
    dailyRates() {
      const currentRoomType = this.$store.getters.currentRoomType;
      let output = [];
      if (currentRoomType) {
        for (let i = 0, l = currentRoomType.DATA.length; i < l; i++) {
          if ('preferred_occupancy_rates' in currentRoomType.DATA[i] && 'occupancy_rates' in currentRoomType.DATA[i] && 'rrcd_rate_date' in currentRoomType.DATA[i]) {
            output.push({
              price: (true === this.$store.getters.showingPreferredOffer && currentRoomType.DATA[i].preferred_occupancy_rates[this.$store.state.bookingLinkData.adults] > 0) ? '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DATA[i].preferred_occupancy_rates[this.$store.state.bookingLinkData.adults], false) : '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DATA[i].occupancy_rates[this.$store.state.bookingLinkData.adults], false),
              priceStrikeThrough: (true === this.$store.getters.showingPreferredOffer && currentRoomType.DATA[i].preferred_occupancy_rates[this.$store.state.bookingLinkData.adults] > 0) ? '$' + window.pepHelperFunctions.formatAsDollarAmount(currentRoomType.DATA[i].occupancy_rates[this.$store.state.bookingLinkData.adults], false) : '',
              date: currentRoomType.DATA[i].rrcd_rate_date,
              displayDate: this.createShortDisplayDate(currentRoomType.DATA[i].rrcd_rate_date)
            });
          }
        }
      }
      return output;
    },
    strikeThroughStateTax() {
      const currentRoomType = this.$store.getters.currentRoomType;
      if (currentRoomType && -1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]) {
        return currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults];
      }
      return 0;
    },
    strikeThroughSubtotal() {
      const currentRoomType = this.$store.getters.currentRoomType;
      if (currentRoomType && -1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]) {
        return currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults];
      }
      return 0;
    },
    strikeThroughTotal() {
      const currentRoomType = this.$store.getters.currentRoomType;
      let total = 0;
      if (currentRoomType && 'DISPLAY' in currentRoomType) {

        if (-1 !== this.$store.state.allowedOfferCodesForPreferred.indexOf(this.$store.state.bookingLinkData.offerCode) && 0 < currentRoomType.DISPLAY.PREFERRED_SUBTOTAL[this.$store.state.bookingLinkData.adults]) {
          total = parseFloat(currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults]);

          total += currentRoomType.DISPLAY.STATE_TAX_RATE * currentRoomType.DISPLAY.SUBTOTAL[this.$store.state.bookingLinkData.adults];
          total += parseFloat(currentRoomType.DISPLAY.TOURISM_SURCHARGE);

          if (this.$store.state.useResortFee) {
            if (this.$store.state.resortFeeSubtotal > 0 && this.$store.state.resortFeeTax > 0) {
              total += this.$store.state.resortFeeSubtotal;
              total += this.$store.state.resortFeeTax;
            }
          }
        }
      }

      return total;
    },


    roomIsAvailable() {
      return !!this.$store.state.roomData.length;
    },


    currentStateTaxStrikeThrough() {
      if (this.strikeThroughStateTax > 0) {
        return '$' + window.pepHelperFunctions.formatAsDollarAmount(this.strikeThroughStateTax, false);
      }
      return '';
    },
    currentSubtotalStrikeThrough() {
      if (this.strikeThroughSubtotal > 0) {
        return '$' + window.pepHelperFunctions.formatAsDollarAmount(this.strikeThroughSubtotal, false);
      }
      return '';
    },
    currentTotalStrikeThrough() {
      if (this.strikeThroughTotal > 0) {
        return '$' + window.pepHelperFunctions.formatAsDollarAmount(this.strikeThroughTotal, false);
      }
      return '';
    },


    changeViewText() {
      if (this.summaryMode) {
        return 'Daily Rates';
      }
      return 'Summary';
    },
    currentViewText() {
      if (this.summaryMode) {
        return 'Summary';
      }
      return 'Details';
    },


    checkInDateDisplay() {
      return this.createShortDisplayDate(this.$store.getters.bookingLinkStartDate);
    },
    checkOutDateDisplay() {
      return this.createShortDisplayDate(this.$store.getters.bookingLinkEndDate);
    }
  },
  methods: {

    toggleMode() {
      this.summaryMode = !this.summaryMode;
    },


    controlMousedown(event: MouseEvent) {
      const closestAnchor = (event.target as HTMLElement | null)?.closest('a');
      if (closestAnchor) {
        closestAnchor.classList.add('mousedown');
      }
    },
    controlMouseup(event: MouseEvent) {
      const closestAnchor = (event.target as HTMLElement | null)?.closest('a');
      if (closestAnchor) {
        closestAnchor.classList.remove('mousedown');
      }
    },


    showTooltip(tooltipType: 'tooltipTotal' | 'tooltipResortFee' | 'tooltipTourismSurcharge', target: HTMLAnchorElement | null): void {
      window.pepConsole.log('showTooltip show loader');
      window.showOverlayDialog({
        alertMode: true,
        confirmBody: this.$store.state[tooltipType] || '',
        callback: 'HIDE-OVERLAY',
      }, target);
    },
    showTooltipTotal(event: MouseEvent): void {
      this.showTooltip('tooltipTotal', event.target?.closest('a'));
    },
    showTooltipResortFee(event: MouseEvent) {
      this.showTooltip('tooltipResortFee', event.target?.closest('a'));
    },
    showTooltipTourismSurcharge(event: MouseEvent) {
      this.showTooltip('tooltipTourismSurcharge', event.target?.closest('a'));
    },


    openCalendar(event: MouseEvent, forceRefresh = false, forceOpen = false) {
      if ('' === this.calendarComponent) {
        this.calendarComponent = 'hotel-calendar';
      } else if (forceRefresh) {
        (this.$refs.calendar as HotelCalendarComponent | null)?.loadTemplate(true);
      }

      if (forceOpen) {
        this.calendarOpen = true;
      } else {
        this.calendarOpen = !this.calendarOpen;
      }

    },


    createShortDisplayDate(date: string | Date) {
      return window.pepDateFunctions.formatShortDisplayDate(date);
    },

    isDaySpecialOffer(day: CalendarDay): boolean {
      return (day.DISPLAY_RATES && day.PRICE !== day.BASE_PRICE)
        || day.OFFER_CODE !== day.OFFER_CODE_STRIKE;
    },

    changeDatesCallback(checkInDate: Date, checkOutDate: Date, initialCheckInDate: Date, initialCheckOutDate: Date, selectedDates: string[]) {

      //check to make sure min stay length is being respected for check in date
      const checkInDay = (this.$refs.calendar as HotelCalendarComponent | null)?.getDayObjectForDate(checkInDate || '');
      if (
        checkInDay
        && checkInDay.MIN_NIGHTS > window.pepDateFunctions.daysBetween(checkInDate, checkOutDate)
      ) {
        window.showOverlayDialog({
          alertMode: false,
          confirmAccept: 'EXTEND STAY',
          confirmDeny: 'CANCEL',
          confirmTitle: 'Minimum Nights Required',
          confirmBody: '<p>Checking in on <strong>' + window.pepDateFunctions.formatDateObjectYYYYMMDD(checkInDate) + '</strong> requires at least ' + checkInDay.MIN_NIGHTS + ' nights.</p><p>Would you like to extend your stay?</p>',
          callback: 'RATE-CALENDAR-EXTEND',
          callbackDeny: 'RATE-CALENDAR-RESET'
        }, this.$el as HTMLElement);

        window.ajaxLinkRegisterCallback(
          'RATE-CALENDAR-EXTEND',
          () => {
            this.$store.commit('updateCheckOutDate', window.pepDateFunctions.addDays(checkInDate, checkInDay.MIN_NIGHTS));
          }
        );
      } else {
        //check if all dates have the same offer
        const nonCheckOutSelectedDates = selectedDates.slice(0, selectedDates.length - 1);
        const specialOfferDays = nonCheckOutSelectedDates.filter((date: string) => {
          const day = (this.$refs.calendar as HotelCalendarComponent | null)?.getDayObjectForDate(date);
          return day && this.isDaySpecialOffer(day);
        });
        const allDatesHaveSpecialOffer = (specialOfferDays.length === nonCheckOutSelectedDates.length);
        const noDatesHaveSpecialOffer = (0 === specialOfferDays.length);

        if (allDatesHaveSpecialOffer || noDatesHaveSpecialOffer) {
          window.showOverlayDialog({
            alertMode: false,
            confirmAccept: 'CONTINUE',
            confirmDeny: 'CANCEL',
            confirmTitle: 'Update Your Reservation?',
            confirmBody: 'Are you sure you want to change your stay dates?',
            callback: 'RATE-CALENDAR-RELOAD',
            callbackDeny: 'RATE-CALENDAR-RESET'
          }, this.$el as HTMLElement);
        } else {
          //need to alert the user that not all dates have the special offer
          window.showOverlayDialog({
            alertMode: false,
            confirmAccept: 'CONTINUE',
            confirmDeny: 'CANCEL',
            confirmTitle: 'Update Your Reservation?',
            confirmBody: 'Special offer not available for all selected dates.</p><p>Special offer will not be used.</p><p>Are you sure you want to change your stay dates?',
            callback: 'RATE-CALENDAR-RELOAD',
            callbackDeny: 'RATE-CALENDAR-RESET'
          }, this.$el as HTMLElement);
        }

        window.ajaxLinkRegisterCallback(
          'RATE-CALENDAR-RELOAD',
          this.rateCalendarReload
        );
      }

      window.ajaxLinkRegisterCallback(
        'RATE-CALENDAR-RESET',
        () => {
          this.$store.commit('updateCheckInDate', initialCheckInDate);
          this.$store.commit('updateCheckOutDate', initialCheckOutDate);
        }
      );
    },

    rateCalendarReload() {
      let updatedBookingLinkData = this.$store.state.bookingLinkData;

      if (!updatedBookingLinkData) return;

      updatedBookingLinkData.start = window.pepDateFunctions.formatDateObjectYYYYMMDD(this.$store.state.checkInDate);
      updatedBookingLinkData.end = window.pepDateFunctions.formatDateObjectYYYYMMDD(this.$store.state.checkOutDate);
      updatedBookingLinkData.stayLength = window.pepDateFunctions.daysBetween(this.$store.state.checkInDate, this.$store.state.checkOutDate);

      let requestData = updatedBookingLinkData;
      requestData.ACTION = 'GET_ROOM_DATA_VIEW_ROOM_DETAILS';

      $.ajax({
        url: '/library/api/room-rates.php',
        type: 'post',
        dataType: 'json',
        data: requestData,
        success: (response: GetRoomDataViewRoomDetailsResponse) => {
          if ('SUCCESS' === response.STATUS) {
            if (response.DATA.hasOwnProperty('ROOM_DATA')) {
              this.$store.commit('updateState', ['roomData', response.DATA.ROOM_DATA]);
              this.$store.commit('updateState', ['bookingLinkData', updatedBookingLinkData]);
              this.$store.commit('currentPrtId', updatedBookingLinkData.extraData.auto_book_prt);
            }
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          window.pepNotify.show(10000, 'An error occurred. Try going back and selecting your new date on the last page.');

          //log this error
          const extraText = (typeof errorThrown === 'string')
            ? ' -- ' + errorThrown
            : '';
          window.pepTracking.event('JS Error', 'Booking Link Update', textStatus + extraText, 0, true);

          $.ajax({
            url: '/library/api/capture-js-error.php',
            dataType: 'json',
            type: 'post',
            data: {
              je_message: 'Booking Link Update',
              je_source: 'https://www.peppermillreno.com/library/js/view-room-details.min.js',
              je_lineno: 0,
              je_colno: 0,
              je_url: window.location.href,
              je_stack: "Status: " + jqXHR.status + "\n\nResponse Text:\n" + jqXHR.responseText
            }
          });

        },
        complete() {
          window.hideLoader(false, true);
        }
      });
    }
  }
})
</script>

<style scoped>
.hotel_calendar--container-vertical:deep(.calendar--grid) {
  overflow: auto;
  max-height: 400px;
}

.view-room-details-table:deep(.calendar--container-has_footer) {
  padding-bottom: 4em;
}

.view-room-details-table:deep(.calendar--month + .calendar--month) {
  margin-top: 3em;
}
</style>